<template>
  <div v-if="!loading" class="game">
    <button class="home-button" @click="goHome()">
      &lt; HOME
    </button>

    <div class="main-container outline">
      <div v-if="showWalkthrough" class="walkthrough">
        <h2>{{walkthrough[step].title}}</h2>
        <p>{{walkthrough[step].text}}</p>

        <div class="row-of-buttons" style="margin-top: 30px">
          <button v-if="step !== 0" class="button" @click="changeStep(-1)">&lt; GO BACK</button>
          <button v-if="step < walkthrough.length - 1" class="button" @click="changeStep(1)">CONTINUE ></button>
          <button v-if="step === walkthrough.length - 1" class="button" @click="skipWalkthrough()">START GAME ></button>
        </div>
        <div>
          <button v-if="step === 0" class="button button-link" @click="skipWalkthrough()">SKIP RULES SUMMARY >>></button>
        </div>
      </div>
      <div v-if="!showWalkthrough" class="messages">
        <Introduction v-bind:introduction="gameState.introduction"/>
        <div v-for="(message, index) in gameState.messages" v-bind:key="index">
          <Question v-if="message.type === 'question'" v-bind:question="message"/>
          <Answer v-if="message.type === 'answer'" v-bind:answer="message"/>
        </div>
        <div class="end-of-messages"></div>
      </div>
    </div>

    <div class="controls">
      <ThisQuestion v-if="!gameState.completed" v-bind:question="gameState.questions[0]" :highlighted="walkthrough[step].highlight === 'ThisQuestion'"/>
      <Compose v-if="!gameState.completed" v-bind:onSubmit="submitAnswer" v-bind:onUndo="undo" v-bind:canUndo="gameState.messages.length > 1" :highlighted="walkthrough[step].highlight === 'Compose'"/>
      <NextQuestion v-if="!gameState.completed" v-bind:questions="gameState.questions" :highlighted="walkthrough[step].highlight === 'NextQuestion'"/>
      <div class="game-complete" v-if="gameState.completed">
        <div class="interview-over">--- INTERVIEW OVER ---</div>
        
        <div>
          <router-link class="button" to='/new'>NEW GAME</router-link>
          <router-link class="button" to='/'>MAIN MENU</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { newGameState } from '../logic/state'
import { saveGame, loadGame } from '../logic/saving'
import Question from '../components/Question'
import Answer from '../components/Answer'
import Compose from '../components/Compose'
import ThisQuestion from '../components/ThisQuestion'
import NextQuestion from '../components/NextQuestion'
import Introduction from '../components/Introduction'

const walkthroughSteps = [
  {
    title: 'Welcome to Sector Six',
    text: 'Stories from Sector Six is a solo journalling RPG and creative writing experience. By answering interview questions, you will create a unique character and story.',
  },
  {
    title: 'Questions',
    text: 'The interviewer will ask you a series of questions that you must answer. The questions are generated by the game and are unique each time you play.',
    highlight: 'ThisQuestion'
  },
  {
    title: 'Upcoming questions',
    text: "However, you can't just answer what you want. Read the 'Upcoming questions' section to find out what the interviewer will ask you next, and make sure your answers make sense in this context.",
    highlight: 'NextQuestion'
  },
  {
    title: 'Writing answers',
    text: "The creativity in Sector Six comes from carefully writing answers which link seamlessly to the upcoming questions, so that the interview as a whole makes sense.",
    highlight: 'Compose'
  },
  {
    title: 'Remember...',
    text: "The questions the interviewer will ask you are chosen at the start of the game and do not change based on your answers. The story will only make sense if YOU make it.",
  },
]

export default {
  name: 'HelloWorld',
  data() {
    return {
      gameState: null,
      loading: true,
      showWalkthrough: true,
      walkthrough: walkthroughSteps,
      step: 0,
    }
  },
  async mounted() {
    const value = await loadGame(this.$route.params.gameId)
    console.log(value)
    if (value) {
      this.gameState = value
    } else {
      this.gameState = newGameState()
    }
    this.loading = false
  },
  methods: {
    submitAnswer(text) {
      console.log(this.gameState.questions);
      this.gameState.messages.push({
        text: this.gameState.questions.shift(),
        type: 'question'
      })
      
      if (this.gameState.questions.length === 0) {
        this.gameState.completed = true
      }

      this.gameState.messages.push({
        text: text,
        type: 'answer'
      })

      this.$nextTick(function() {
        const el = this.$el.getElementsByClassName('end-of-messages')[0];
        if (el) {
          el.scrollIntoView({behavior: 'smooth'});
        }
      })

      saveGame(this.$route.params.gameId, this.gameState)
    },
    undo() {
      const lastAnswer = this.gameState.messages.pop().text
      const lastQuestion = this.gameState.messages.pop().text
      this.gameState.questions.unshift(lastQuestion)
      return lastAnswer
    },
    goHome() {
      this.$router.push({name: 'Home'})
    },
    skipWalkthrough() {
      this.showWalkthrough = false
    },
    changeStep(step) {
      this.step += step
    }
  },
  props: {

  },
  components: {
    Question, Answer, Compose, NextQuestion, ThisQuestion, Introduction
  }
}
</script>

<style scoped>
.game {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  overflow: hidden;
}

.messages {
  font-size: 18px;
  width: 100%;
}

.main-container {
  width: 100%;
  max-width: 750px;
  height: calc(100vh - 60px);
  margin: 30px;
  overflow: auto;
  flex-grow: 1;
  padding: 20px;
}

.home-button {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 16px;
}

.game-complete {
  width: 90%;
  max-width: 800px;
  text-align: center;
  margin: 0 auto 10px;
}

.button {
  margin: 8px auto;
}

.interview-over {
  margin-bottom: 18px;
  font-size: 30px;
  font-weight: 700;
}

.controls {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 550px;
  margin-right: 30px;
}

.walkthrough {
  padding: 10px;
  max-width: 500px;
  margin: 0 auto;
}

@media screen and (max-width: 700px) {
  .game {
    display: block;
  }

  .main-container {
    width: calc(100% - 40px);
    height: auto;
    min-height: 400px;
    margin: 20px;
    margin-top: 50px;
  }

  .main-container.outline {
    border: none;
    padding: 0;
    box-shadow: none;
  }

  .messages {
    width: 100%;
    max-width: initial;
    border-radius: 0;
    border: none;
    font-size: 16px;
    margin-bottom: 3px;
    margin-top: 0;
  }

  .game-complete {
    width: calc(100% - 20px);
    font-size: 16px;
    margin: 0 10px 10px;
  }

  .walkthrough {
    padding: 20px;
  }

  .controls {
    width: calc(100% - 40px);
    margin: 20px;
  }
}
</style>
